import { useTheme } from "@/contexts/ThemeContext";
import { Sun, Moon, Laptop } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function ThemeToggle() {
  const { pref, resolved, setTheme } = useTheme();
  // Cycle: light → dark → system → light…
  const next = pref === "light" ? "dark" : pref === "dark" ? "system" : "light";

  const Icon = pref === "system" ? Laptop : resolved === "dark" ? Moon : Sun;
  const label = pref === "system" ? "System" : resolved === "dark" ? "Dark" : "Light";

  return (
    <button
      onClick={() => setTheme(next)}
      data-testid="theme-toggle"
      aria-label={`Theme: ${label}. Click to switch.`}
      title={`Theme: ${label}. Click to switch.`}
      className="inline-flex items-center gap-1.5 px-2 py-1.5 border border-[#E5E5E5] hover:border-[#0A0A0A] text-[10px] uppercase tracking-[0.15em] font-bold transition-colors"
    >
      <Icon className="w-3.5 h-3.5" strokeWidth={2.5} />
      <span className="hidden lg:inline">{label}</span>
    </button>
  );
}
